import type { PostOfficeMessageInstance } from '@atlassian/post-office-headless-api/hooks/useMessageInstances';
import type {
	PlacementMessage,
	PlacementMessageDiscriminant,
} from '@atlassian/post-office-headless-api/hooks/usePlacementData';

import type { mapToAvailableConnectors, useOAuthHandlers } from '../banner-placement';

export type FullConnectorVariant = 'admin-blessed-missing-results' | 'social-proof-high';
export type SmartLinkVariant = 'social-proof-low' | 'social-proof-high';
export type BannerVariant = FullConnectorVariant | SmartLinkVariant;

export type QuickFindHeadlessMessageContext = {
	productSource: string;
	fullConnectorVariant: FullConnectorVariant;
	smartLinkVariant: SmartLinkVariant;
	lastDismissed3P: string;
	dismissalCount: number;
	teamConnectAppPercentage?: number;
};

export const QUICK_FIND_TEMPLATE_ID = 'rovo-search-page-quick-find-3p-connector-pre-auth-nudge';

export type QuickFindHeadlessMessage =
	PlacementMessageDiscriminant<QuickFindHeadlessMessageContext> & {
		messageTemplateId: typeof QUICK_FIND_TEMPLATE_ID;
		context: QuickFindHeadlessMessageContext;
	};

export type QuickFindHeadlessMessageInstance = PlacementMessage<QuickFindHeadlessMessage>;
export type QuickFindHeadlessAvailableConnectors = ReturnType<typeof mapToAvailableConnectors>;
export type QuickFindHeadlessAvailableConnector = QuickFindHeadlessAvailableConnectors[number];

export type QuickFindHeadlessRendererProps = {
	message: QuickFindHeadlessMessageInstance;
	availableConnectors: QuickFindHeadlessAvailableConnectors;
	useOAuthHandlers: useOAuthHandlers;
	dismissMessage: (messageInstanceId: string) => void;
	PostOfficeMessageInstance: PostOfficeMessageInstance;
};
